(function() {
    'use strict';

    angular
        .module('bhsApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('formations', {
             parent: 'bhs',
            url: '/formulaire-formations/:id/:idCCI/:idCampagneSelected',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CCIR'],
                pageTitle: 'bhsApp.formulaires.accidentTrajet.title'
            },
            views: {
                'content@bhs': {
                    templateUrl: 'app/formulaire/formulaire-formations.html',
                    controller: 'FormulaireFormationsCtrl',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('paramFormulaire');
                    $translatePartialLoader.addPart('paramTableau');
                    return $translate.refresh();
                }],
                entityCCI: ['CCI', '$stateParams', function(CCI, $stateParams){
                   return CCI.get({id: $stateParams.idCCI});
                }],
                entityCampagne: ['Campagne', '$stateParams', function(Campagne, $stateParams){
                   return Campagne.getCampagneSelectedAndTheTwoPreviousWithoutTheirFormulaires({idCampagneSelected: $stateParams.idCampagneSelected});
                }]
            }
        });
    }
})();
